<div class="pricing-container" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <header class="pricing-header">
    <h1 class="pricing-title">Elige tu plan y lleva tu flujo de trabajo al siguiente nivel.</h1>
  </header>
  <div class="pricing-content">

    <!-- Plans -->
    <div class="plans-container">
      <!-- Plan Gratis -->
      <div class="plan-card">
        <div class="plan-header">
          <h2 class="plan-name">Gratis</h2>
          <div class="plan-price">
            <span class="price-amount">$0</span>
            <span class="price-period">MXN/mes</span>
          </div>
          <p class="plan-tagline">Obtén acceso básico para probar la app y descubrir sus funciones creativas.</p>
        </div>
        <button class="plan-button current-plan" disabled>Tu plan actual</button>
        <ul class="plan-features">
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Procesamiento de imágenes en formato .zip, .jpg, .png y .webp</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Edición básica de imágenes </span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Ajuste de tamaño, recorte, relleno de imagen y color de fondo</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Plantillas predefinidas </span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Exportación estándar en png  </span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Máximo 10 imágenes por día </span>
          </li>
        </ul>
      </div>

      <!-- Plan Plus -->
      <div class="plan-card">
        <div class="plan-header">
          <h2 class="plan-name">Plus</h2>
          <div class="plan-price">
            <span class="price-amount">$365</span>
            <span class="price-period">MNX/mes</span>
          </div>
          <p class="plan-tagline">Más acceso a funciones nuevas y potentes para aumentar tu productividad y creatividad.</p>
        </div>
        <button class="plan-button secondary" (click)="selectPlanById('plus')">Obtener Plus</button>
        <ul class="plan-features">
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Procesamiento de hasta 400 imágenes en formato .zip, .jpg, .png y .webp.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Todos los beneficios del Plan Free.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Exportación estándar en png.</span>
          </li>
        </ul>
      </div>

      <!-- Plan Pro -->
      <div class="plan-card featured">
        <div class="popular-badge">POPULAR</div>
        <div class="plan-header">
          <h2 class="plan-name">Pro</h2>
          <div class="plan-price">
            <span class="price-amount">$1099</span>
            <span class="price-period">MXN/mes</span>
          </div>
          <p class="plan-tagline">Integración total para equipos y desarrolladores que buscan automatizar su flujo creativo.</p>
        </div>
        <button class="plan-button primary" (click)="selectPlanById('pro')">Obtener Pro</button>
        <ul class="plan-features">
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Todas las funciones de Plan Plus.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Integración directa en tus aplicaciones.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Integración via API REST.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Exportación de hasta 10,000 imágenes por mes.</span>
          </li>
        </ul>
      </div>

      <!-- Plan Enterprice -->
      <div class="plan-card">
        <div class="plan-header">
          <h2 class="plan-name">Enterprise</h2>
          <div class="plan-price">
            <span class="price-amount">$4979</span>
            <span class="price-period">MXN/mes</span>
          </div>
          <p class="plan-tagline">Escala tu proyecto con IA generando miles de imágenes directamente desde tu sitio cada mes.</p>
        </div>
        <button class="plan-button secondary" (click)="selectPlanById('enterprise')">Obtener Enterprice</button>
        <ul class="plan-features">
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Todas las funciones de Plan Pro.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Generación de imágenes con IA 25,000 créditos mensuales.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Royalty Free por empresa.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Plan ilimitado por sitio.</span>
          </li>
          <li class="feature-item">
            <svg class="feature-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span>Exportación ilimitada de imágenes.</span>
          </li>
        </ul>
      </div>

    </div>
  </div>

  <!-- Modal de Pago -->
  <div *ngIf="showPaymentModal" class="payment-modal-overlay" (click)="closePaymentModal()">
    <div class="payment-modal" (click)="$event.stopPropagation()">
      <div class="payment-modal-header">
        <h2 class="payment-modal-title">Completa tu suscripción</h2>
        <button class="payment-modal-close" (click)="closePaymentModal()" title="Cerrar">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <div class="payment-modal-content">
        <div *ngIf="selectedPlan" class="selected-plan-info">
          <h3>{{ selectedPlan.name }}</h3>
          <p class="plan-price-info">${{ selectedPlan.price }} {{ selectedPlan.currency }}/{{ selectedPlan.period }}</p>
          <p class="plan-tagline-info">{{ selectedPlan.tagline }}</p>
        </div>

        <!-- Card Payment Brick Container -->
        <div id="card-payment-brick" class="card-payment-brick-container"></div>

        <!-- Payment Status -->
        <div *ngIf="paymentStatus === 'processing'" class="payment-status processing">
          <div class="spinner"></div>
          <p>Procesando tu pago...</p>
        </div>

        <div *ngIf="paymentStatus === 'success'" class="payment-status success">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <p>{{ paymentSuccessMessage }}</p>
        </div>

        <div *ngIf="paymentStatus === 'error'" class="payment-status error">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <p>{{ paymentErrorMessage }}</p>
          <button class="retry-button" (click)="paymentStatus = 'idle'">Intentar nuevamente</button>
        </div>
      </div>
    </div>
  </div>
  <footer>
    <div class="footer-container">
      <p data-i18n="footerCopyright">&copy; 2025 Punto de Fuga. Todos los derechos reservados.</p>
      <div class="footer-links">
        <a routerLink="/privacy" data-i18n="footerPrivacy">Política de Privacidad</a>
        <a routerLink="/support" data-i18n="footerContact">Soporte</a>
      </div>
    </div>
  </footer>
</div>
